var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBorderBottomRight = function SvgBorderBottomRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 35h52.5c16.569 0 30-13.431 30-30V0",
    stroke: "#000"
  })));
};

export default SvgBorderBottomRight;